
export default class GlobalConst {
    
    // 相机机 orbit 控制器
    static CAMERA_CONTROLE_MODE_ORBIT ="orbit";
    // 相机机 firstPerson 控制器
    static CAMERA_CONTROLE_MODE_FIRSTPERSON ="firstPerson";
    // 相机机 pointerLock 控制器
    static CAMERA_CONTROLE_MODE_POINTERLOCK ="pointerLock";
    // 相机机 map 控制器
    static CAMERA_CONTROLE_MODE_MAP ="map";

}
